import React, { Component } from 'react';
//import Button from "react-bootstrap/Button";
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { SAVE_MAINTENANCE, DOCUMENTS_NAME } from '../MaintenanceDoc';
import { SAVE_COMPLIANCE, SAVE_CONTRACTS } from '../ComplianceAndContract';
import './dialog.css';
import Cookie from 'js-cookie';
import axios from 'axios';
import { Config } from '../../../config/config';
// import { ThemeProvider } from '@mui/material/styles'; commented as it might be required check once
import Spinner from '../../../UIComponents/Spinner/Spinner';
import MessageBox from '../../../UIComponents/MessageBox/MessageBox';
import { ApiGateWay } from '../../../ApiGateWay/ApiGateWay';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import TextField from '@mui/material/TextField';
import moment from 'moment';
import LZString from 'lz-string';
import dayjs from 'dayjs';


class UploadDocDialog extends Component {
  constructor(props) {
    super(props);

    const config = JSON.parse(Config);
    let storeId;
    const jsonData = Cookie.get('currentUser');
              let decompressedData = LZString.decompressFromBase64(jsonData);
          decompressedData = decompressedData =='\x00\x00\x00'?jsonData:decompressedData;
    const userInfo = JSON.parse(decompressedData) 
    let userId = userInfo['userId'];

    let date = new Date();

    let m = ('0' + (date.getMonth() + 1)).slice(-2);
    let d = ('0' + date.getDate()).slice(-2);

    date = date.getFullYear() + '-' + m + '-' + d;

    let today = date.toString();

    let tab = props.index;

    this.state = {
      o: false,
      expiryDate: '',
      date: '',
      tab,
      startDate: '',
      today,
      vendorName: '',
      storeId: this.props.storeId,
      documentPath: '',
      userId,
      selectedFile: null,
      config,
      proxyjson: [],
      documentType: '',
      documentTypeId: '',
      documentName: '',
      loading: false,
      modalOpen: false,
      selectFile: false,
      message: '',
    };

    // if (this.props.storeId === undefined) {
    //   this.state.storeId = 3;
    // } else this.state.storeId = this.props.storeId;
  }

  handleClickOpen = () => {
    this.setState({
      o: true,
      documentType: '',
      vendorName: '',
      documentName: '',
    });
  };

  componentDidMount() {
    /*
      Data for the Document Type select is dynamic and is loaded from the server. Based on which tab is selected, The appropriate api is called.
      
    */
    this.setState({
      startDate: this.state.today,
      expiryDate: this.state.today,
    });

    // if (this.props.storeId === undefined) {
    //   this.state.storeId = 3;
    // } else this.state.storeId = this.props.storeId;

    if (this.state.tab === 3) {
      DOCUMENTS_NAME('/loadMaintenanceDocuments', this.state.storeId)
        .then((response) => {
          this.setState({
            proxyjson: response,
            loading: false,
          });
        })
        .catch(() => {
          this.setState({
            loading: false,
            modalOpen: true,
            message: 'Unable to retrieve the data. Please try again later',
          });
        });
    } else if (this.state.tab === 2) {
      DOCUMENTS_NAME('/loadContract', this.state.storeId)
        .then((response) => {
          this.setState({
            proxyjson: response,
            loading: false,
          });
        })
        .catch(() => {
          this.setState({
            loading: false,
            modalOpen: true,
            message: 'Unable to retrieve the data. Please try again later',
          });
        });
    } else if (this.state.tab === 1) {
      DOCUMENTS_NAME('/loadCompliance', this.state.storeId)
        .then((response) => {
          this.setState({
            proxyjson: response,
            loading: false,
          });
        })
        .catch((error) => {
          this.setState({
            loading: false,
            modalOpen: true,
            message: 'Unable to retrieve the data. Please try again later',
          });
        });
    }
  }

  handleClose = (e) => {
    /*
      Based on if the dialog is closed/Submitted, respective ifelse is executed,
      e===1 = dialog is submitted.

      The document is first uploaded into the server using the /upload api and then the response - documentPath is then used as parameter for the /saveCompilance or maintenance or 
      contract api to link the document to the appropriate type.

      
    */

    this.props.setUploadEditing(false);
    if (e === 1) {
      if (!this.state.selectFile) {
        this.setState({
          o: true,
        });

        toast.error('Please choose the file!', {
          position: 'top-right',
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        this.setState({
          o: false,
          loading: true,
        });

        let headers = {
          Authorization: 'Bearer ' + JSON.parse(Cookie.get('token')),
          'Access-Control-Allow-Origin': '*',
          'x-api-key': process.env.REACT_APP_X_API_KEY,
        };
        //Upload Doc
        const data = new FormData();
        data.append('file', this.state.selectedFile);
        axios
          .post(
            process.env.REACT_APP_UPLOAD_DOWNLOAD +
              this.state.config['api'] +
              '/upload',
            data,
            {
              headers: headers,
            }
          )
          .then((response) => {
            this.setState({
              documentPath: response.data.key,
            });

            if (this.state.documentTypeId === '') {
              this.state.documentTypeId = this.state.proxyjson[0][0];
            }
            if (this.state.tab === 1 && response.data.key) {
              console.log(this.state.tab);
              let eDate = new Date(this.state.expiryDate).toISOString();

              let requestModel = {
                expiryDate: eDate,
                documentPath: response.data.key,
                storeId: this.state.storeId,
                uploadBy: this.state.userId,
                documentStatus: 'Yes',
                documentId: this.state.documentTypeId,
              };

              ApiGateWay.Post(
                this.state.config['api'] + '/saveCompliance',
                requestModel
              )
                .then((response) => response.json())
                .then((response) => {
                  if (response) {
                    this.setState({
                      loading: false,
                      modalOpen: true,
                      message: 'Document Uploaded Successfully',
                    });

                    this.props.setUploadEditing(true);
                  }
                })
                .catch((error) => {
                  //
                  this.setState({
                    loading: false,
                    modalOpen: true,
                    message: 'Please try gain after some time',
                  });
                });
              // SAVE_COMPLIANCE('/saveCompliance', requestModel)
              //   .then((response) => {
              //     this.setState({
              //       loading: false,
              //       modalOpen: true,
              //       message: 'Document Uploaded Successfully',
              //     });

              //     this.props.setUploadEditing(true);

              //     //window.location.reload('false');
              //   })
              //   .catch(() => {
              //     this.setState({
              //       loading: false,
              //       modalOpen: true,
              //       message:
              //         'There seems to be some error, Please try again later',
              //     });
              //   });
            } else if (this.state.tab === 2 && response.data.key) {
              let eDate = new Date(this.state.expiryDate).toISOString();
              let sDate = new Date(this.state.startDate).toISOString();
              let requestModel = {
                contractExpiryDate: eDate,
                documentPath: response.data.key,
                storeId: this.state.storeId,
                vendorName: this.state.vendorName,
                contractStartDate: sDate,
                uploadBy: this.state.userId,
                documentStatus: 'Yes',
                documentId: this.state.documentTypeId,
              };
              ApiGateWay.Post(
                this.state.config['api'] + '/saveContracts',
                requestModel
              )
                .then((response) => response.json())
                .then((response) => {
                  if (response) {
                    this.setState({
                      loading: false,
                      modalOpen: true,
                      message: 'Document Uploaded Successfully',
                    });
                    this.props.setUploadEditing(true);
                  }
                })
                .catch((error) => {
                  //
                  this.setState({
                    loading: false,
                    modalOpen: true,
                    message: 'Please try gain after some time',
                  });
                });
              // SAVE_CONTRACTS('/saveContracts', requestModel)
              //   .then(() => {
              //     this.setState({
              //       loading: false,
              //       modalOpen: true,
              //       message: 'Document Uploaded Successfully',
              //     });
              //     this.props.setUploadEditing(true);
              //   })
              //   .catch((error) => {
              //     this.setState({
              //       loading: false,
              //       modalOpen: true,
              //       message:
              //         'There seems to be some error, Please try again later',
              //     });
              //   });
            } else if (this.state.tab === 3 && response.data.key) {
              let requestModel = {
                documentPath: response.data.key,
                storeId: this.state.storeId,
                uploadBy: this.state.userId,
                documentName: this.state.documentName,
                documentTypeId: this.state.documentTypeId,
              };
              ApiGateWay.Post(
                this.state.config['api'] + '/saveMaintenanceDocument',
                requestModel
              )
                .then((response) => response.json())
                .then((response) => {
                  if (response) {
                    this.setState({
                      loading: false,
                      modalOpen: true,
                      message: 'Document Uploaded Successfully',
                    });
                    this.props.setUploadEditing(true);
                  }
                })
                .catch((error) => {
                  //
                  this.setState({
                    loading: false,
                    modalOpen: true,
                    message: 'Please try gain after some time',
                  });
                });
              // SAVE_MAINTENANCE('/saveMaintenanceDocument', requestModel)
              //   .then((response) => {
              //     this.setState({
              //       loading: false,
              //       modalOpen: true,
              //       message: 'Document Uploaded Successfully',
              //     });
              //     this.props.setUploadEditing(true);
              //   })

              //   .catch(() => {
              //     this.setState({
              //       loading: false,
              //       modalOpen: true,
              //       message:
              //         'There seems to be some error, Please try again later',
              //     });
              //   });
            } else {
              this.setState({
                loading: false,
                modalOpen: true,
                message: 'Unable to upload please try again',
              });
            }
          })
          .catch(() => {
            this.setState({
              loading: false,
              modalOpen: true,
              message: 'There seems to be some error, Please try again later',
            });
          });
      }
    } else {
      this.setState({
        expiryDate: '',
        o: false,
        selectedFile: null,
        loading: false,
      });
    }
  };

  createSelectItems() {}

  handleSelect = (e) => {
    //let f = e.target.selectedIndex;  documentTypeId: e.target.childNodes[f].id,
    if (e.target.value) {
      this.state.proxyjson.forEach((element) => {
        if (element[1] == e.target.value) {
          this.setState({
            documentType: e.target.value,
            documentTypeId: element[0],
          });
        }
      });
    }
  };

  handleFile = (event) => {
    this.setState({
      selectedFile: event.target.files[0],
      selectFile: true,
    });
  };

  handleValidation() {
    let b;
    if (this.state.tab === 1) {
      this.state.documentType === '' ? (b = true) : (b = false);
    } else if (this.state.tab === 2) {
      this.state.documentType === '' ||
      // this.state.expiryDate === '' ||
      this.state.startDate === '' ||
      this.state.vendorName === ''
        ? (b = true)
        : (b = false);
    } else
      this.state.documentType === '' || this.state.documentType === ''
        ? (b = true)
        : (b = false);

    return b;
  }

  handleChange = (prop) => (event) => {
    this.setState({
      [prop]: event.target.value,
    });
  };
  render() {
    const { loading, modalOpen, message } = this.state;
    return (
      <>
        {modalOpen ? (
          <MessageBox
            message={message}
            signout={false}
            onClose={this.handleClose}
          />
        ) : null}
        {loading ? (
          <Spinner />
        ) : (
          // <ThemeProvider injectFirst>
            <div className='row'>
              <div className='col-md-12 test'>
                <div>
                  <button
                    onClick={this.handleClickOpen}
                    className='deca-btn-yellow'
                  >
                    Upload Documents
                  </button>
                  <ToastContainer
                    position='top-right'
                    autoClose={2000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    className=''
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                  />
                </div>
                <div>
                  <Dialog
                    open={this.state.o}
                    onClose={this.handleClose}
                    aria-labelledby='form-dialog-title'
                  >
                    <DialogTitle className='uploadDocTitle'>
                      <h4 className='uploadDocTitleText'>
                        Upload Document
                        <IconButton
                          aria-label='close'
                          className='uploadDocIcon'
                          onClick={this.handleClose}
                        >
                          <CloseIcon />
                        </IconButton>{' '}
                      </h4>
                    </DialogTitle>

                    <DialogContent>
                      <div className='DocUploadDialog'>
                        {this.state.tab == 2 ? (
                          <>
                            <div
                              className='row'
                              style={{
                                marginLeft: '33px',
                                marginBottom: '30px',
                              }}
                            >
                              <InputLabel
                                id='demo-simple-select-label'
                                style={{ fontSize: '20px', marginTop: '20px' }}
                              >
                                Document Type:
                              </InputLabel>
                              <Select
                                labelId='demo-simple-select-standard-label'
                                name='documentType'
                                label='Document Type'
                                value={this.state.documentType}
                                id='age-native-simple'
                                style={{ width: '300px', fontSize: '20px' }}
                                onChange={this.handleSelect}
                                required
                                variant='standard'
                              >
                                {this.state.proxyjson.map((e, key) => {
                                  return (
                                    <MenuItem key={key} value={e[1]} id={e[0]}>
                                      {e[1]}
                                    </MenuItem>
                                  );
                                })}
                              </Select>
                            </div>
                            <div
                              className='row'
                              style={{
                                marginLeft: '33px',
                                marginTop: '10px',
                                marginBottom: '30px',
                              }}
                            >
                              <TextField
                                type='date'
                                error={this.state.startDate === ''}
                                id='Startdate'
                                // InputProps={{
                                //   inputProps: {
                                //     min: moment().format('YYYY-MM-DD'),
                                //   },
                                // }}
                                defaultValue={dayjs().format('YYYY-MM-DD')}
                                label='Contract Start date'
                                onChange={this.handleChange('startDate')}
                                variant='standard'
                              />
                            </div>

                            <div
                              className='row'
                              style={{
                                marginLeft: '30px',
                                marginBottom: '30px',
                              }}
                            >
                              <TextField
                                id='standard-basic'
                                label='Vendor Name'
                                value={this.state.vendorName}
                                onChange={this.handleChange('vendorName')}
                                style={{ width: '310px' }}
                                variant='standard'
                              />
                            </div>

                            <div
                              className='row'
                              style={{
                                marginLeft: '33px',
                                marginTop: '10px',
                                marginBottom: '30px',
                              }}
                            >
                              <TextField
                                id='expirydate'
                                label='Expiry Date'
                                type='date'
                                // InputProps={{
                                //   inputProps: {
                                //     min: moment().format('YYYY-MM-DD'),
                                //   },
                                // }}
                                // error={this.state.expiryDate === ''}
                                defaultValue={dayjs().format('YYYY-MM-DD')}
                                onChange={this.handleChange('expiryDate')}
                                variant='standard'
                              />
                            </div>
                          </>
                        ) : this.state.tab === 1 ? (
                          <>
                            <div
                              className='row'
                              style={{
                                marginLeft: '33px',
                                marginBottom: '30px',
                              }}
                            >
                              <InputLabel
                                id='demo-simple-select-label'
                                style={{ fontSize: '20px', marginTop: '20px' }}
                              >
                                Document Type:
                              </InputLabel>
                              <Select
                                labelId='demo-simple-select-label'
                                name='documentType'
                                label='Document Type'
                                value={this.state.documentType}
                                id='age-native-simple'
                                style={{ width: '300px', fontSize: '20px' }}
                                onChange={this.handleSelect}
                                required
                                variant='standard'
                              >
                                {this.state.proxyjson.map((e, key) => {
                                  return (
                                    <MenuItem key={key} value={e[1]} id={e[0]}>
                                      {e[1]}
                                    </MenuItem>
                                  );
                                })}
                              </Select>
                            </div>
                            <div
                              className='row'
                              style={{
                                marginLeft: '33px',
                                marginTop: '10px',
                                marginBottom: '30px',
                              }}
                            >
                              <TextField
                                id='expirydate'
                                label='Expiry Date'
                                type='date'
                                InputProps={{
                                  inputProps: {
                                    min: dayjs().format('YYYY-MM-DD'),
                                  },
                                }}
                                defaultValue={dayjs().format('YYYY-MM-DD')}
                                onChange={this.handleChange('expiryDate')}
                                variant='standard'
                              />
                            </div>
                          </>
                        ) : (
                          <div>
                            <div
                              className='row'
                              style={{
                                marginLeft: '33px',
                                marginBottom: '15px',
                              }}
                            >
                              <InputLabel
                                id='demo-simple-select-label'
                                style={{ fontSize: '20px', marginTop: '20px' }}
                              >
                                Document Type:
                              </InputLabel>
                              <Select
                              // native
                                labelId='demo-simple-select-label'
                                name='documentType'
                                label='Document Type'
                                value={this.state.documentType}
                                id='age-native-simple'
                                style={{ width: '300px', fontSize: '20px' }}
                                onChange={this.handleSelect}
                                variant='standard'
                                className='menuitem-select-value'
                              >
                                {this.state.proxyjson.map((e, key) => {
                                  return (
                                    <MenuItem key={key} value={e[1]} id={e[0]} >
                                      {e[1]}
                                    </MenuItem>
                                  );
                                })}
                              </Select>
                            </div>
                            <br></br>
                            <div className='row' style={{ marginLeft: '33px' }}>
                              <TextField
                                value={this.state.documentName}
                                onChange={this.handleChange('documentName')}
                                id='Startdate'
                                label='Document Name'
                                style={{ width: '310px' }}
                                variant='standard'
                              />
                            </div>
                            <br></br>
                          </div>
                        )}
                        <input
                          className='uploadDocFile'
                          type='file'
                          onChange={this.handleFile}
                          required
                        />
                        <div className='row'>
                          <button
                            className='btn muted-button  deca-btn-orange a-btn-cancel'
                            onClick={() => this.handleClose(0)}
                            type='button'
                            style={{ marginBottom: '40px' }}
                          >
                            Cancel
                          </button>

                          <button
                            className='btn btn-secondary deca-btn-yellow a-update-email-alert'
                            onClick={() => this.handleClose(1)}
                            color='primary'
                            disabled={this.handleValidation()}
                            style={{ marginBottom: '40px' }}
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    </DialogContent>
                  </Dialog>
                </div>
              </div>
            </div>
          // </ThemeProvider>
        )}
      </>
    );
  }
}

export default UploadDocDialog;
